import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.updateJobApplication
)

export const selectInspectJobApplicationModalOpen = createSelector(
    baseSelector,
    (state) => state.isInspectJobApplicationModalOpen
)

export const selectApproveJobApplicationModalOpen = createSelector(
    baseSelector,
    (state) => state.isApproveJobApplicationModalOpen
)

export const selectRejectJobApplicationModalOpen = createSelector(
    baseSelector,
    (state) => state.isRejectJobApplicationModalOpen
)

export const selectOnApprove = createSelector(
    baseSelector,
    (state) => state.onApprove
)

export const selectOnReject = createSelector(
    baseSelector,
    (state) => state.onReject
)

export const selectCurrentApplication = createSelector(
    baseSelector,
    (state) => state.currentApplication
)